import React, { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Dialog, InputText } from "iuvity-ui-components";
import { AppContext } from "../../context";
import { ErrorMessage } from "@hookform/error-message";
import { ApplicationCreatorSchema } from "../../validations/schemas";


interface DeleteApplicationProps {
  visible: boolean;
  closeHandler: Function;
  confirmHandler: Function;
  dataAppSeleted?: any;
}


export const DeleteApplication: React.FC<DeleteApplicationProps> = ({
  visible,
  closeHandler,
  confirmHandler,
  dataAppSeleted,
}) => {
  const {
    t,
    appState: { selectedApplication },

  } = useContext(AppContext);

  const {
    control,
    formState: { errors, isValid },
    watch,
    resetField,
    setError,
  } = useForm({
    mode: "onBlur",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues:
    {
      name: ""
    }
  });
  useEffect(() => {
    resetField('name');
  }, [visible])



  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-flex-end">
        <Button
          label={t("Applications.noLabel")}
          onClick={() => closeHandler()}
          className="mr-4"
          variant="p-button-text"
        />
        <Button
          label={t("Applications.yesLabel")}
          className="mr-4"
          variant="p-button"
          disabled={(!(isValid && watch('name') == selectedApplication?.name))}
          onClick={() => confirmHandler()}
        />
      </div>
    );
  };

  return (
    <Dialog
      id="dialogScroll1"
      className="dialog-form"
      header={<>{t("Applications.confirmDeleteApp")}</>}
      visible={visible}
      onHide={() => closeHandler()}
      style={{ width: "25.4375rem", height: 'auto' }}
      footer={renderFooter}
      draggable={false}
    >
      <p className="pb-4 description-delete-app">
        {t("Applications.descriptionDeleteApp1")}
      </p>
      <div
        className=""
      >
        <Controller
          name={'name' as any}
          control={control}
          rules={{
            ...(ApplicationCreatorSchema(t) as any)['name'],
            validate: (value) => {
                if (value) {
                    value !== dataAppSeleted?.name
                        ? setError('name', { type: 'validate', message: t('GlobalConfigurations.generalErrorMessage') })
                        : setError('name', { type: 'validate', message: undefined })
                }
            }
          }}
          render={({ field }) => {
            return <div className='app-fields' style={{ width: '100%', marginLeft: '1.5rem' }}>
              <InputText
                id={`input-label-name}`}
                label={t(`Applications.deleteNameLabel`)}
                placeholder={t(`Applications.deleteNamePlaceholder`)}
                className={errors.name?.message ? "p-invalid mt-2" : "mb-4 mt-2"}
                type="text"
                autoComplete="off"
                keyfilter={ApplicationCreatorSchema(t)?.name?.keyfilter}
                maxLength={ApplicationCreatorSchema(t)?.name?.maxLength?.value}
                {...field}
                value={field.value}
              />
            </div>

          }}
        />
        {['name'].includes('name') &&
          <ErrorMessage
            errors={errors}
            name="name"
            //@ts-ignore
            render={({ message }) => (
              <small
                className="p-error"
                style={{ marginTop: "0.5rem", marginBottom: "1rem", marginLeft: "1.5rem", display: !message ? 'none' : 'block' }}
              >
                {message}
              </small>
            )}
          />}
      </div>
      <p className="description-delete-app">
        <div dangerouslySetInnerHTML={{ __html: t('Applications.descriptionDeleteApp2') }} />
      </p>
    </Dialog>
  );
};
